module.exports = __webpack_public_path__ + "static/live-room-1-67fa144d512a3a6bbb86d0b2d8d5ad6e.jpg";